import React        from 'react';
import PropTypes    from 'prop-types';
import UrlBuilder   from '../../../utils/UrlBuilder';
import withSuspense from '../../HigherOrderComponents/Utility/withSuspense';
import Flux         from '../../../flux/Flux';
import { VXPay }    from '../../../utils/VXPay';
import LogoLoader   from '../../Loader/LogoLoader';

const VXShaka = React.lazy(() => import("../../VXShaka/VXShaka"));


class FeedBlockSliderTile extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
            hasLiked:      this.props.tile.guestState && this.props.tile.guestState.liked,
            likes:         this.props.tile.likes,
            isMuted:       true,
            isPlaying:     false,
            isVideoLoaded: false,
            isInitialized: false,
            tileWidth:     null,
		};

        this.likeRef;
        this.videoRef;
        this.shakaPlayer;
        this.posterRef;

        this.onPlayChange      = this.onPlayChange.bind(this);
        this.onMouseEnterVideo = this.onMouseEnterVideo.bind(this);
        this.onMuteClick       = this.onMuteClick.bind(this);
        this.storeVideoRef     = this.storeVideoRef.bind(this);
        this.onLoadedMetadata  = this.onLoadedMetadata.bind(this);
        this.onVideoEnded      = this.onVideoEnded.bind(this);
	}

    componentDidMount() {
        Flux.Feed.addBlockVideoPlayChangeListener(this.onPlayChange);
    }

    componentWillUnmount() {
        Flux.Feed.removeBlockVideoPlayChangeListener(this.onPlayChange);
    }

    onPlayChange(postId) {
        if (this.isVideo()) {
            if (postId === this.props.tile.id) {
                const isMuted = Flux.VXMobile.isIOS() ? true : Flux.Feed.getBlockVideoMute();
                this.setState({isPlaying: true, isMuted, isInitialized: true}, () => {
                    setTimeout(() => {
                        this.videoRef.play();
                        this.videoRef.muted = isMuted;
                    }, 50);
                });
            } else {
                this.setState({isPlaying: false, isMuted: true}, () => {
                    this.videoRef && this.videoRef.pause();
                });
            }
        }
    }

    onMouseEnterVideo() {
        if (this.isVideo() && !this.state.isPlaying) {
            Flux.Feed.toggleBlockVideoPlay(this.props.tile.id);
        }
    }

    onMuteClick() {
        if (this.state.isPlaying && this.videoRef) {
            const isMuted = !this.state.isMuted;
            Flux.Feed.setBlockVideoMute(isMuted);
            this.setState({isMuted: isMuted}, () => {
                this.videoRef.muted = isMuted;
            });
        }
    }

    isVideo() {
        return !!this.props.tile.clip;
    }

    onVideoEnded() {
        this.props.onVideoEnd(this.props.tile.id);
    }

    getSliderTileOverlay(tile) {
        return <div className={'feed-block__slider-tile__overlay'} onMouseEnter={this.onMouseEnterVideo}>
            {this.isVideo() && <div className='feed-block__slider-tile__overlay-mute' ><i className={'icon ' + (this.state.isMuted ? '-icon-speaker-muted-full' : '-icon-speaker-full')}></i></div>}
            <div className='feed-block__slider-tile__overlay__click-area'>
                <div className={"h-cursor-pointer"} onClick={this.onMuteClick}></div>
                <div className={"h-cursor-pointer"} onClick={(e) => this.onClickModel(e, tile.model.name, tile.id)}></div>
            </div>
            <h3 className='feed-block__slider-tile__overlay-info'>
                <a href={this.getUrl(tile.model.name, tile.id)} onClick={(e) => this.onClickModel(e, tile.model.name, tile.id)} className={'feed-block__slider-tile__overlay-image' + (tile.model.online ? " feed-block__slider-tile__overlay-image--online" : "")}><img src={tile.model.avatar ? tile.model.avatar.url : "https://www.visit-x.net/assets/img/navbar/guest_dummy.jpg"} loading="lazy" /></a>
                <a href={this.getUrl(tile.model.name, tile.id)} onClick={(e) => this.onClickModel(e, tile.model.name, tile.id)} className={'feed-block__slider-tile__overlay-name'}>{tile.model.name}</a>
                <div className={'feed-block__slider-tile__overlay-likes' + (this.props.isMobile ? "" : " h-cursor-pointer")} onClick={(e) => this.toggleLikeFunc(e, tile.id)} ref={(ref) => this.likeRef = ref}>
                    <i className={'icon ' + (this.state.hasLiked ? "-icon-like-full" : "-icon-like-line")}></i>
                    {this.state.likes}
                </div>
            </h3>
            <a href={this.getUrl(tile.model.name, tile.id)} onClick={(e) => this.onClickModel(e, tile.model.name, tile.id)} className={'feed-block__slider-tile__overlay-title'}>{tile.title}</a>
        </div>;
    }

    getUrl(name, postId) {
        return UrlBuilder.buildActorProfileUrl(name) + (this.props.isMobile ? "?postId=" + postId : "");
    }

    onClickModel(e, name, postId) {
        e.preventDefault();
        e.stopPropagation();
        this.props.onClickModel(this.getUrl(name, postId));
    }

    toggleLikeFunc(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!Flux.Guest.isLoggedIn()) {
            VXPay.openSignupOrLogin({
				host: parseInt(this.props.tile.model.id),
			});
            return;
        }

		const liked = this.state.hasLiked;
        let likes   = this.state.likes;

		if (liked) {
			Flux.Feed.unlikePost(this.props.tile.id, () => {});
            likes -= 1;
		} else {
            Flux.Feed.likePost(this.props.tile.id, Flux.Constants.Feed.FeedType.STARTPAGE, () => {});
            likes += 1;
		}

        this.likeRef.classList.add('feed-block__slider-tile__overlay-likes--animation');
			setTimeout(() => {
				this.likeRef.classList.remove('feed-block__slider-tile__overlay-likes--animation');
			}, 500);
        this.setState({hasLiked: !liked, likes});
	}

    storeVideoRef(ref) {
        if (ref) {
            this.videoRef = ref;
        }
    }

    onLoadedMetadata() {
        this.setState({isVideoLoaded: true});
    }

    setTileRef(ref) {
        if (ref) {
            this.setState({tileWidth: ref.getBoundingClientRect().width});
        }
    }

    render() {
        const tile = this.props.tile;
        let content = null;
        if (this.state.tileWidth) {
            switch(tile.type) {
                case 'PHOTOS':
                    content = <div className='feed-block__slider-tile'>
                        <img className='feed-block__slider-tile__blurred' srcSet={tile.photos[0].srcSet} sizes={`${this.state.tileWidth}px`} loading="lazy" />
                        <img className='feed-block__slider-tile__photo' srcSet={tile.photos[0].srcSet} sizes={`${this.state.tileWidth}px`} loading="lazy"/>
                    </div>;
                    break;
                case 'CLIP':
                case 'FP_HOT_CLIP':
                        if (!this.shakaPlayer) { // Special Handling because ref video muting wont work after rerender a new shaka
                            this.shakaPlayer = this.state.isInitialized ? withSuspense(<VXShaka
                            src={tile.clip.sources[0] && tile.clip.sources[0].src}
                            videoType={tile.clip.sources[0] && tile.clip.sources[0].type}
                            controlsVisible={false}
                            storeVideoRef={this.storeVideoRef}
                            autoplay={true}
                            onEnded={this.onVideoEnded}
                            onLoadedMetadata={this.onLoadedMetadata}
                        />) : null;
                        }
                    const isWide = this.props.tile.clip.ratio > 1 && this.state.isVideoLoaded;
                    content = <div className={'feed-block__slider-tile' + (isWide ? " feed-block__slider-tile--wide" : "")} style={{position: 'relative'}}>
                            <img className='feed-block__slider-tile__blurred' src={tile.clip.poster.url} loading="lazy"/>
                            {this.shakaPlayer}
                            {!this.state.isVideoLoaded && <img className='feed-block__slider-tile__photo feed-block__slider-tile__photo--absolute' src={tile.clip.poster.url} loading="lazy"/>}
                            {this.state.isInitialized && !this.state.isVideoLoaded && <LogoLoader className="-absolute--bg" pulse/>}
                    </div>;
                    break;
            }
        }

        return <div className='feed-block__slider-tile-wrapper' ref={ref => this.setTileRef(ref)}>
            {content}
            {this.getSliderTileOverlay(tile)}
            </div>;
	}
}

FeedBlockSliderTile.propTypes = {
	tile:         PropTypes.object.isRequired,
    isMobile:     PropTypes.bool.isRequired,
    onClickModel: PropTypes.func.isRequired,
    sliderRef:    PropTypes.shape({current: PropTypes.instanceOf(Element)}),
    onVideoEnd:   PropTypes.func,
};

FeedBlockSliderTile.defaultProps = {
    sliderRef:  null,
    onVideoEnd: null,
};


export default FeedBlockSliderTile;
